import { useTranslation } from 'react-i18next';

export function useTranslatedProduct(product) {
  const { t } = useTranslation('products');

  if (!product) return null;

  const id = product.id;

  // Get translated aiSummary
  const aiSummary = t(`products:${id}.aiSummary`, { defaultValue: product.aiSummary });

  // Get translated keyFeatures (returnObjects for arrays)
  let keyFeatures = product.keyFeatures;
  try {
    const translated = t(`products:${id}.keyFeatures`, { returnObjects: true });
    if (Array.isArray(translated) && translated.length > 0) {
      keyFeatures = translated;
    }
  } catch (e) {
    // fallback to original
  }

  // Get translated specs (returnObjects for arrays)
  let specs = product.specs;
  try {
    const translated = t(`products:${id}.specs`, { returnObjects: true });
    if (Array.isArray(translated) && translated.length > 0) {
      specs = translated;
    }
  } catch (e) {
    // fallback to original
  }

  return {
    ...product,
    aiSummary,
    keyFeatures,
    specs,
  };
}
